import ServicePreviewCard from './ServicePreviewCard';
import { ServiceId } from './serviceDefinitions';

type OfficeServiceCardProps = {
  onSelect: (serviceId: ServiceId) => void;
};

export default function OfficeServiceCard({
  onSelect,
}: OfficeServiceCardProps) {
  return <ServicePreviewCard serviceId='office_clean' onSelect={onSelect} />;
}
